<template>
    <div class="top-btn" id="top-btn" v-on:click="scrollToTop" v-if="scrollTop>300"></div>
</template>

<script>
export default{
    name: 'top-btn',
    data(){
        return {
            scrolled: false,
            scrollTop: 0
        }
    },
    created (){
         window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
         window.removeEventListener('scroll', this.handleScroll)
     },
     methods:{
        handleScroll () {
            let self = this
            self.scrolled = window.scrollY > 0
            self.scrollTop = window.scrollY
        },
        scrollToTop: function(){
            $('html,body').animate({ scrollTop: 0 }, 700)
        }
     }
}
</script>

<style lang="sass" scoped>
@mixin rwd($w)
	@media only screen and (max-width: $w) 
		@content
.top-btn
	position: fixed
	background-image: url(../assets/images/top-btn.png)
	width: 52px
	height: 52px
	background-size: contain
	cursor: pointer
	right: 5%
	bottom: 10%
	z-index: 50
+rwd(1200px)
    .top-btn
        right: 0
        bottom: 87px
        width: 100px
        height: 100px
</style>



// WEBPACK FOOTER //
// btnGoTop.vue?0fb16f33